import React, { useContext } from 'react'
import {ShopContext} from '../context/ShopContext'
import axios from 'axios'
import { toast } from 'react-toastify'

const NewsletterBox = () => {

  const { backendUrl } = useContext(ShopContext)

    const onSubmitHandler = (e) =>{
        e.preventDefault();
        const email = e.target.value;
        axios.post(backendUrl + '/api/user/subscribe',{email}).then(res => toast.success(res.response.message)).catch(err => toast.error(err.response.message));
    }

  return (
    <div className='text-center'>
      <p className='text-2xl font-medium text-gray-800'>Subscribe Now & get 20% Off</p>
      <p className='text-gray-400 mt-3'>
      Stay in the Loop with Our Latest Curtain Collections! <br />
      Sign up for our newsletter and be the first to know about new arrivals, exclusive offers, and design tips. Get inspired with our curated collections and special deals delivered straight to your inbox. Plus, enjoy expert advice on how to transform your space with the perfect curtains! <br />
      Join today and start decorating with style!
      </p>
      <form onSubmit={onSubmitHandler} className='w-full sm:w-1/2 flex items-center gap-3 mx-auto my-6 border pl-3'>
        <input className='w-full sm:flex-1 outline-none' type="email" placeholder='Enter Your Email' required />
        <button type='submit' className='bg-black text-white text-xs px-10 py-4'>SUBSCRIBE</button>
      </form>
    </div>
  )
}

export default NewsletterBox
